(window.OELogoList = function ($, Behaviors) {
    "use strict";

    const module = {};

    function OELogoList() {
        const logoModules = document.querySelectorAll('.tt-logo-list');

        if (!logoModules.length || !document.querySelectorAll('.tt-logo-list .swiper-slide').length) {
            return;
        }

        logoModules.forEach(logoModule => {
            const config = {
                'ttSliderNumberOfSlides': logoModule.dataset.ttSliderNumberOfSlides,
                'ttSliderDisableOnInteraction': logoModule.dataset.ttSliderDisableOnInteraction
            };

            const disableOnInteraction = config.ttSliderDisableOnInteraction === 'yes';

            const swiperSettings = {
                slidesPerView: 'auto',
                pagination: false,
                spaceBetween: 50,
                loop: true,
                speed: 4000,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: disableOnInteraction,
                },
                freeMode : {
                    enabled: true,
                    momentumBounce: false,
                },
                // breakpoints: {
                //     480: {
                //         slidesPerView: 4,
                //         spaceBetween: 60
                //     },
                //     768: {
                //         slidesPerView: config.ttSliderNumberOfSlides !== '' ? config.ttSliderNumberOfSlides : 4,
                //         spaceBetween: 60
                //     }
                // }
            };

            const swiper = new Swiper(logoModule, swiperSettings);
        });
    }

    module.OELogoList = OELogoList;

    document.addEventListener('DOMContentLoaded', OELogoList);

    return module;

}(window.jQuery, window.Behaviors));

